export default "__VITE_ASSET__BRyk2nWM__"